module.exports = __webpack_public_path__ + "static/img/z_proposal2.9993314.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ce/z_proposal2.jpg
// module id = Kru/
// module chunks = 171